import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, publishLast, refCount, take } from 'rxjs/operators';
import { Validation, ContractType, PersonType } from '../../models';
import { ErrorMessage, CssClass } from '../../constants';
import { GtmDatalayerUiService } from '../gtm-datalayer/gtm-datalayer-ui.service';

@Injectable({
  providedIn: 'root'
})
export class PrimaryDOBValidationService {
  constructor(private gtmDataLayerUiService: GtmDatalayerUiService) {

  }
  dobValidSubject: Subject<Validation> = new Subject<Validation>();
  dobValid$ = this.dobValidSubject.asObservable();
  isInValid(contractType: ContractType): boolean {
    let validation = this.dobValidation(contractType.policyHolder)
    this.setError(validation);
    return validation.isInValid;
  }
  private dobValidation(person: PersonType[]): Validation {
    let validation: Validation = new Validation();
    validation.isInValid = false;
    if (person.length == 0 || person[0].birthDate == null || person[0].birthDate == undefined || person[0].birthDate == "Invalid Date") {
      validation.isInValid = true;
      validation.errorCss = CssClass.error;
      validation.errorMessage = ErrorMessage.providePrimaryDOB;
      this.gtmDataLayerUiService.setCjError(ErrorMessage.providePrimaryDOB)
    }
    else if (person[0].birthDate == ErrorMessage.insurerInvalidAge) {
      validation.isInValid = true;
      validation.errorCss = CssClass.error;
      validation.errorMessage = ErrorMessage.insurerInvalidAge;
      this.gtmDataLayerUiService.setCjError(ErrorMessage.insurerInvalidAge)

    }
    else if (person[0].birthDate == ErrorMessage.futureDate) {
      validation.isInValid = true;
      validation.errorCss = CssClass.error;
      validation.errorMessage = ErrorMessage.futureDate;
      this.gtmDataLayerUiService.setCjError(ErrorMessage.futureDate)
    }
    return validation;
  }
  setError(error: Validation) {
    this.dobValidSubject.next(error);
  }
}
